import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { User } from 'oidc-client';
import { RoleCodes } from 'core/enums/role';
import { AppCodes } from 'core/enums/appCodes';
import { StorageService } from '../storage/storage.service';
import { StorageKeys } from 'core/enums/storage-keys';
import { TokenData } from '../models/token-data';
@Injectable({
  providedIn: 'root'
})

/**
 * Authorization Services
 * the main service for Authorization
 */
export class AuthorizationService {
  httpService = inject(HttpClient);
  storageService = inject(StorageService);
  router = inject(Router);
  constructor() {}

  get accessToken(): string | null | undefined {
    return this.storageService.getItemFromSessionStorage(StorageKeys.AccessToken);
  }

  public validateToken = (): boolean => {
    const tokenResult = this.storageService.getItemFromSessionStorage(StorageKeys.TokenData)!;
    const tokenData = JSON.parse(tokenResult) as TokenData;
    if (tokenData == null) {
      return false;
    } else {
      const tokenDate = this.toDateTime(tokenData.Expiry);
      return new Date() < new Date(tokenDate);
    }
  };

  public startSession = (user: User) => {
    this.mapRoles(user.profile.roles);
    const tokenData = {
      Token: user.access_token,
      Expiry: user.expires_in
    };
    sessionStorage.setItem('TokenData', JSON.stringify(tokenData));
    sessionStorage.setItem('token', user.access_token);
  };

  public getRoles = (): any[] => {
    const rolesResult = sessionStorage.getItem('Roles')!;
    const roles = JSON.parse(rolesResult) as any[];
    const mappedRoles: any[] = [];
    if (roles !== null && roles !== undefined) {
      roles.map(e => {
        mappedRoles.push({
          roleName: e?.RoleName,
          roleNameAr: e?.RoleNameAr,
          roleId: e?.RoleId,
          appId: e?.AppId,
          roleCode: e?.RoleCode
        });
      });
    }
    return mappedRoles;
  };

  public isAuthorized = (data: any): boolean => {
    if (data.isAnonymous) {
      return true;
    }
    const p = this.getPermission(data.permission);
    if (p) {
      return true;
    }
    return false;
  };

  /**
   * Get Permission
   * @param id
   * @returns
   */
  public getPermission = (id: string): string | undefined => {
    const permissionListResult = sessionStorage.getItem('Permissions')!;
    if (permissionListResult) {
      const permissionList = JSON.parse(permissionListResult) as any;
      const permission = permissionList.permissions.find((x: any) => x === id);
      return permission;
    }
    return undefined;
  };
  /**
   * Get Page Permissions
   * @param page
   * @returns
   */
  public getPagePermission = (page: string): string[] => {
    const permissionListResult = sessionStorage.getItem('Permissions')!;
    const permissionList = JSON.parse(permissionListResult) as any;
    const permissions = permissionList.permissions.filter((x: any) => x.includes(page));
    return permissions;
  };

  public isAdmin = (): boolean => {
    const rolesResult = sessionStorage.getItem('Roles')!;
    const roles = JSON.parse(rolesResult) as any[];
    if (roles !== undefined && roles !== null) {
      const role = roles.find(x => x.RoleCode === RoleCodes.Administrator);
      if (role !== undefined && role !== null) {
        return true;
      }
      return false;
    }
    return false;
  };

  public setPermissions = (permissions: any[]): void => {
    this.mapPermissions(permissions);
  };

  private mapPermissions = (permissions: any[]) => {
    const appPermission = permissions.find(x => x.appCode === AppCodes.AppCode);
    sessionStorage.setItem('Permissions', JSON.stringify(appPermission));
  };

  private mapRoles = (roles: any): void => {
    const parsedRoles = JSON.parse(roles);
    const appRoles = parsedRoles.filter((x: any) => x.AppCode === AppCodes.AppCode);
    sessionStorage.setItem('Roles', JSON.stringify(appRoles));
  };

  toDateTime = (secs: any) => {
    const t = new Date();
    t.setSeconds(secs);
    return t;
  };
}
